import React from 'react';

// Visually identical to the inline #llg-boot skeleton in public/index.html.
// React's createRoot wipes the container on first render, so every stage that
// can still be pending after boot — the lazy route chunk, the prefill token
// exchange — must repaint the same thing or the signer sees the spinner
// vanish into a bare navy screen and assumes the link is broken.
function FormLoading() {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '60vh',
        gap: '1rem',
        fontFamily: "'Work Sans', system-ui, -apple-system, sans-serif",
        color: '#fff',
      }}
    >
      <div
        style={{
          width: 34,
          height: 34,
          border: '3px solid rgba(255,255,255,0.25)',
          borderTopColor: '#fff',
          borderRadius: '50%',
          animation: 'llg-spin 0.9s linear infinite',
        }}
      />
      <p style={{ margin: 0, opacity: 0.85, fontSize: '0.95rem' }}>Loading your form…</p>
    </div>
  );
}

export default FormLoading;
